import { Fee } from '../types';

export interface WalletPassData {
  eventName: string;
  eventDate: string;
  eventLocation: string;
  ticketType: string;
  quantity: number;
  ticketNumber: string;
  qrCodeData: string;
}

export const generateWalletPassData = (fee: Fee, ticketType: string, quantity: number): WalletPassData => {
  const ticketNumber = `${fee.id.substring(0, 8).toUpperCase()}-${Date.now().toString(36).toUpperCase()}`;

  const qrCodeData = JSON.stringify({
    eventId: fee.id,
    eventName: fee.name,
    ticketType,
    quantity,
    ticketNumber,
    timestamp: Date.now(),
  });

  return {
    eventName: fee.name,
    eventDate: fee.availableFrom.toLocaleDateString('en-US', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    }),
    eventLocation: fee.description,
    ticketType,
    quantity,
    ticketNumber,
    qrCodeData,
  };
};

export const generateAppleWalletUrl = (passData: WalletPassData): string => {
  const params = new URLSearchParams({
    event: passData.eventName,
    date: passData.eventDate,
    type: passData.ticketType,
    ticket: passData.ticketNumber,
  });

  return `https://api.example.com/wallet/apple?${params.toString()}`;
};

export const generateGooglePayUrl = (passData: WalletPassData): string => {
  const params = new URLSearchParams({
    event: passData.eventName,
    date: passData.eventDate,
    type: passData.ticketType,
    ticket: passData.ticketNumber,
  });

  return `https://api.example.com/wallet/google?${params.toString()}`;
};

export const downloadWalletPass = (passData: WalletPassData, type: 'apple' | 'google') => {
  const url = type === 'apple' ? generateAppleWalletUrl(passData) : generateGooglePayUrl(passData);
  window.open(url, '_blank');
};
